module.exports = __webpack_public_path__ + "img/boy_010003.a0b15080.png";